module.exports = __webpack_public_path__ + "static/noData.880e1f8f.png";